import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import isConsumer from "owa-session-store/lib/utils/isConsumer";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { getOcpsPolicyFromLocalStore } from "./getOcpsPolicyFromLocalStore";
import type { OcpsPolicy } from "./OcpsPolicy";
import type { MailboxInfo } from "owa-client-types";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export default function isOcpsPolicyEnabled(policy: OcpsPolicy, enabledIfUndefined?: boolean, mailboxInfo?: MailboxInfo): boolean {
    if (isConsumer(undefined, mailboxInfo)) {
        return true;
    }
    
    if (!isAccountFeatureEnabled("ocps-policy-check", mailboxInfo ?? getGlobalSettingsAccountMailboxInfo())) {
        return enabledIfUndefined !== undefined ? enabledIfUndefined : true;
    }
    
    if (!mailboxInfo) {
        mailboxInfo = getModuleContextMailboxInfo();
    }
    
    const policyState = getOcpsPolicyFromLocalStore(mailboxInfo, policy);
    if (policyState) {
        return policyState === "1";
    }
    
    return enabledIfUndefined ?? false;
}
